import React from 'react';
import './navbar.css';

export default function NavBig() {

    return (
        <nav className="navbar navbar-expand-sm navbar-light fixed-top nav_big_screen animate__animated animate__slideInDown">
            <div className="nav--container container-fluid mt-4">
                <a className="nav--brand" href="#Cover">david piredda</a>
                <div className="nav--command--big collapse navbar-collapse" id="navbarData">
                    <ul className="nav--links text-end">
                        <li className="nav-item me-4">
                            <a className="nav--link" aria-current="page" href="#About">
                                <i className="bi bi-person link--icons"></i>
                                About
                            </a>
                        </li>
                        <li className="nav-item me-4">
                            <a className="nav--link" href="#Specializations">
                                <i className="bi bi-sliders link--icons"></i>
                                Specializations
                            </a>
                        </li>
                        <li className="nav-item me-4">
                            <a className="nav--link" href="#Projects">
                                <i className="bi bi-view-list link--icons"></i>
                                Projects
                            </a>
                        </li>
                        <li className="nav-item me-4">
                            <a className="nav--link" href="#Contact">
                                <i className="bi bi-envelope link--icons"></i>
                                Contact
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}
